import { createI18n } from 'vue-i18n/index';
import dict from '@/modules/locales/dict';
import links from '@/modules/locales/links';

const LANGUAGES = [ 'ru', 'en' ]
const sources = [ dict, links ]

const messages = {}
LANGUAGES.forEach(lang => {
    sources.forEach(source => {
        messages[lang] = {
            ...messages[lang],
            ...source[lang],
        }
    })
})

export const locales = {
    languages: LANGUAGES,
    i18n: createI18n({
        locale: 'en',
        fallbackLocale: 'en',
        messages,
        warnHtmlInMessage: 'off',
    })
};